import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./components/common_components/common_css/common_slider_css/Common_slider_css.css";
import "./index.css";

import Contact_us from "./components/contact_us/Contact_us";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import Privacy_policy from "./components/privacy_policy/Privacy_policy";
import Profile from "./components/profile/Profile";
import Recharge_wallate from "./components/recharge_wallate/Recharge_wallate";
import Refer_and_earn from "./components/refer_and_earn/Refer_and_earn";
import Services from "./components/services/Services";
import DTH_Recharge from "./components/services/payment_recharge_details/dth_Recharge/DTH_Recharge";
import Dth_recharge_details from "./components/services/payment_recharge_details/dth_Recharge/dth_recharge_details/Dth_recharge_details";
import Electricity_Bill from "./components/services/payment_recharge_details/electricity_Bill/Electricity_Bill";
import Electricity_recharge_details from "./components/services/payment_recharge_details/electricity_Bill/electricity_recharge_details/Electricity_recharge_details";
import Fastag_Recharges from "./components/services/payment_recharge_details/fastag_Recharges/Fastag_Recharges";
import FASTag_recharge_details from "./components/services/payment_recharge_details/fastag_Recharges/fastag_recharge_details/FASTag_recharge_details";
import Gas_Cylinder from "./components/services/payment_recharge_details/gas_Cylinder/Gas_Cylinder";
import Gas_Cylinder_recharge_details from "./components/services/payment_recharge_details/gas_Cylinder/gas_Cylinder_recharge_details/Gas_Cylinder_recharge_details";
import Mobile_Recharge from "./components/services/payment_recharge_details/mobile_Recharge/Mobile_Recharge";
import Airtel_Prepaid from "./components/services/payment_recharge_details/mobile_Recharge/airtel_Prepaid/Airtel_Prepaid";
import Mobile_rech_view_plans from "./components/services/payment_recharge_details/mobile_Recharge/mobile_recharge_view_plans/Mobile_rech_view_plans";
import Terms_conditions from "./components/terms_and_condition/Terms_conditions";
import Upgraded_profile from "./components/upgrade_menu_offcanvas/upgraded_profile/Upgraded_profile";
import My_team_details from "./components/upgrade_menu_offcanvas/my_team_details/My_team_details";
import Current_rank from "./components/upgrade_menu_offcanvas/current_rank/Current_rank";
import Main_wallet from "./components/upgrade_menu_offcanvas/main_wallet/Main_wallet";
import Main_wallet_Withdrowal from "./components/upgrade_menu_offcanvas/main_wallet/main_wallet_Withdrowal/Main_wallet_Withdrowal";
import Task_income from "./components/upgrade_menu_offcanvas/main_wallet/task_income/Task_income";
import Rewards from "./components/upgrade_menu_offcanvas/rewards/Rewards";
import My_rewards from "./components/upgrade_menu_offcanvas/rewards/my_rewards/My_rewards";
import Kyc_and_Bank_details from "./components/upgrade_menu_offcanvas/kyc_and_Bank_details/Kyc_and_Bank_details";
import Explore_game from "./components/explore_game/Explore_game";
import Game_page_1 from "./components/game/game_page_1/Game_page_1";
import Daily_Task_btn from "./components/common_components/daily_Task_btn/Daily_Task_btn";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";

function App() {
  const location = useLocation();

  // Hide footer when on /game_page_1, /explore-game, or any /explore-game/... path
  const shouldHideFooter =
    location.pathname.startsWith("/explore-game/");

const isExploreHomePage = location.pathname === "/";


  return (
    <>
    <ScrollToTop/>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/refer-and-earn" element={<Refer_and_earn />} />
        <Route path="/recharge-wallate" element={<Recharge_wallate />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/contact-us" element={<Contact_us />} />

        {/* Mobile Recharge */}
        <Route path="/mobile-recharge" element={<Mobile_Recharge />} />
        <Route path="/mobile-prepaid-recharge" element={<Airtel_Prepaid />} />
        <Route path="/view-plans" element={<Mobile_rech_view_plans />} />

        {/* DTH Recharge */}
        <Route path="/dth-recharge" element={<DTH_Recharge />} />
        <Route path="/dth-recharge-details-plans" element={<Dth_recharge_details />} />

        {/* Electricity Bill */}
        <Route path="/electricity-recharge" element={<Electricity_Bill />} />
        <Route path="/electricity-bill-details-plans" element={<Electricity_recharge_details />} />

        {/* Gas Cylinder */}
        <Route path="/gas-recharge" element={<Gas_Cylinder />} />
        <Route path="/gas-cylinder-recharge-details-plans" element={<Gas_Cylinder_recharge_details />} />

        {/* Fastag Recharge */}
        <Route path="/fastag-recharge" element={<Fastag_Recharges />} />
        <Route path="/fastag-recharge-details-plans" element={<FASTag_recharge_details />} />

        {/* Legal Pages */}
        <Route path="/terms-and-condition" element={<Terms_conditions />} />
        <Route path="/privacy-policy" element={<Privacy_policy />} />

        {/* Upgrade Menu Offcanvas */}
        <Route path="/upgraded-profile" element={<Upgraded_profile />} />
        <Route path="/my-team-details" element={<My_team_details />} />
        <Route path="/current-rank" element={<Current_rank />} />
        <Route path="/main-wallet" element={<Main_wallet />} />
        <Route path="/main-wallet-withdrowal" element={<Main_wallet_Withdrowal />} />
        <Route path="/main-wallet-task-income" element={<Task_income />} />
        <Route path="/rewards" element={<Rewards />} />
        <Route path="/my-rewards" element={<My_rewards />} />
        <Route path="/kyc-and-bank-details" element={<Kyc_and_Bank_details />} />

        {/* Explore Game Routes */}
        <Route path="/explore-game" element={<Explore_game />} />
        <Route path="/explore-game/onetouch-roulette" element={<Game_page_1 />} />
      </Routes>


        {/* {isExploreHomePage ? <Daily_Task_btn /> : ""} */}


      {!shouldHideFooter && <Footer />}
    </>
  );
}

export default App;
